import waitingOverlayTpl from '../templates/waiting_overlay.html';

export default function waitingOverlay() {
  return {
    tempalte: waitingOverlayTpl,
    restrict: 'E'
  };
}
